// Auto generated file, do not manually modify!
// com.hotpads.zcalendar.client.enums.TourType

export enum TourType {
  IN_PERSON = 'IN_PERSON',
  OPEN_HOUSE = 'OPEN_HOUSE',
}

export const TourType_values = [TourType.IN_PERSON, TourType.OPEN_HOUSE] as const;
